import { Grid, TextField } from "@mui/material";
import Field from "components/Field";
import { useIntl } from "react-intl";
import { MetaValueFieldProps } from "pages/AttributesPage/CustomAttributeComponents/metaValueComponents";
import { AttributeMetaValues } from "types/common-types";

const labelKeys: Partial<Record<string, string>> = {
  [AttributeMetaValues.Company]: "locationFormCompanyLabel",
  [AttributeMetaValues.Address1]: "locationFormAddress1Label",
  [AttributeMetaValues.Address2]: "locationFormAddress2Label",
  [AttributeMetaValues.Address3]: "locationFormAddress3Label",
  [AttributeMetaValues.City]: "cityLabel",
  [AttributeMetaValues.ZipCode]: "locationFormZipCodeLabel",
  [AttributeMetaValues.Phone]: "locationFormPhoneLabel",
  [AttributeMetaValues.Fax]: "locationFormFaxLabel",
  [AttributeMetaValues.Email]: "emailLabel",
};

export function TextFieldField({
  metaValueName,
  index,
  attributeMetaValues,
}: MetaValueFieldProps) {
  const { formatMessage: t } = useIntl();

  const existingValue = attributeMetaValues?.find(
    (m) => m.name === metaValueName,
  )?.value;

  const labelKey = labelKeys[metaValueName] ?? metaValueName;

  return (
    <>
      <Field
        name={`attributeMetaValues[${index}].name`}
        initialValue={metaValueName}
      >
        {() => null}
      </Field>
      <Field
        name={`attributeMetaValues[${index}].value`}
        initialValue={existingValue ?? ""}
      >
        {({ input, meta }) => (
          <Grid item xs={12}>
            <TextField
              variant="standard"
              fullWidth
              label={t({ id: labelKey })}
              error={meta.error && meta.submitFailed}
              helperText={meta.error && meta.submitFailed && meta.error}
              {...input}
            />
          </Grid>
        )}
      </Field>
    </>
  );
}
